import type { ViewerInputApi } from '@mindcloudxai/shared';
import type { ViewerContext } from '../types';

export function createInputApi(getCtx: () => ViewerContext): ViewerInputApi {
  return {
    setMode: (mode) => setInputMode(getCtx(), mode),
    setGamingControls: (enabled) => setGamingControls(getCtx(), enabled),
  };
}

function setInputMode(ctx: ViewerContext, mode: Parameters<ViewerInputApi['setMode']>[0]): void {
  if (!ctx.global) return;
  ctx.global.state.inputMode = mode;
}

function setGamingControls(
  ctx: ViewerContext,
  enabled: Parameters<ViewerInputApi['setGamingControls']>[0],
): void {
  if (!ctx.global) return;
  ctx.global.state.gamingControls = enabled;
}
